module.exports = __webpack_public_path__ + "img/pauli-z-root-1.6376609c.svg";